import { take, fork, cancel, call, put, cancelled, takeLatest } from "redux-saga/effects"
import { setAIBase, setMultiBaseList } from "../actions/multiAiBase"
import {
	azureAdGetLoginUrlFailed,
	azureAdGetLoginUrlFailedClear,
	azureAdGetLoginUrlSuccess,
	azureAdLoginRequestFailed,
	azureAdLoginRequestFailedClear,
	azureAdLoginRequestSuccess,
	logoutUser,
	logoutUserActionSuccess,
	logoutUserActionFailure,
	forgotPasswordSuccess,
	forgotPasswordFailure,
	resetPasswordSuccess,
	resetPasswordFailure,
	redirectToHome,
} from "../actions/userActions"
import { history } from "../helpers/history"
import { userService } from "../services/user.services"
import axios from "../services/axios"
import { clearMultibase } from "../actions/multiAiBase"

import {
	LOGIN_REQUEST,
	LOGIN_SUCCESS,
	LOGIN_FAILURE,
	LOGOUT,
	HIDE_ALERT,
	REQUEST_SOURCES,
	REQUEST_CUSTOM_TAGS,
	SHOW_ALERT,
	AZUREAD_LOGIN_URL_REQUEST,
	AZUREAD_LOGIN_REQUEST,
	LOGOUT_USER,
	FORGET_PASSWORD,
	RESET_PASSWORD,
} from "../types/index"

function* loginFlow(action) {
	// console.log(action.payload);
	const { username, password } = action.payload
	//When login is call request data from API
	//User is login
	// dispatch(alertActions.hideAlertAction());
	yield put({ type: HIDE_ALERT, payload: null })
	//Request API
	try {
		try {
			// const response = yield call (clienteAxios.post,'/auth/token', qs.stringify({ 'username': username, 'password': password }));
			const response = yield call(userService.login, username, password)
			// const response = userService.login(username, password);
			// console.log(response);
			// console.log(response.token.access_token);

			//Verificar los datos que envía la API
			if (
				response !== undefined &&
				response.hasOwnProperty("success") &&
				response.success !== true &&
				response.message === "Too many Users"
			) {
				// dispatch(failureUser("You have reached the maximum number of concurrent users. Please contact your administrator and try again."));
				yield put({
					type: LOGIN_FAILURE,
					payload: "You have reached the maximum number of concurrent users. Please contact your administrator and try again.",
				})
				// history.push('/login-error');
				// yield call(history.push,'/login-error');
				return
			}

			if (response.token === undefined) {
				// dispatch(userActions.failureUser(user.msg));
				yield put({
					type: LOGIN_FAILURE,
					payload: "No token found",
				})

				// dispatch(alertActions.showAlert({
				//     msg: 'User or password not valid',
				//     class: 'alert alert-danger'
				// }));
				let alert = { msg: "User or password not valid", class: "alert alert-danger" }
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
			} else {
				// dispatch(successUser(user));
				// console.log(response);
				const availableProjects = response.token?.available_projects

				yield put({
					type: LOGIN_SUCCESS,
					payload: response,
				})
				// dispatch(requestSources());
				//yield put ({type: REQUEST_SOURCES});
				// dispatch(requestCustomTags());
				//yield put ({type: REQUEST_CUSTOM_TAGS});

				yield put(setMultiBaseList(availableProjects))
				yield put(setAIBase(availableProjects[0]))
				localStorage.setItem("selectedProject", JSON.stringify(availableProjects[0]))

				//Comprobar aquí si tiene docs
				const params = new URL(window.location.href).searchParams
				if (params.get("downloads") === null) {
					// history.push('/search');
					yield call(history.push, "/dashboard")
				} else {
					// history.push('/downloads?downloads='+params.get('downloads'));
					yield call(history.push, "/downloads?downloads=" + params.get("downloads"))
				}
			}
		} catch (error) {
			// dispatch(failureUser(error));
			console.log(error)
			yield put({
				type: LOGIN_FAILURE,
				payload: error,
			})
			// dispatch(alertActions.showAlertAction({
			//     msg: 'User or password not valid',
			//     class: 'alert alert-danger'
			// }));
			let alert = { msg: "User or password not valid", class: "alert alert-danger" }
			yield put({
				type: SHOW_ALERT,
				payload: alert,
			})
		}
	} catch (error) {
		// dispatch(failureUser(error));
		yield put({
			type: LOGIN_FAILURE,
			payload: error,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'User or password not valid',
		//     class: 'alert alert-danger'
		// }));
		let alert = { msg: "User or password not valid", class: "alert alert-danger" }
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* logoutFlow(action) {
	userService.logoutUser()
	// dispatch(logoutUser());
	// history.push('/');
	yield call(history.push, "/")
}

const getAzureAdLoginURL = async () => {
	return await axios.get(`/auth/generate-auth-url`)
}

function* getAzureAdURLSaga(action) {
	try {
		const result = yield call(getAzureAdLoginURL)
		if (result.status === 200 && result.data.success === true) {
			yield put(azureAdGetLoginUrlSuccess(result.data.data))
		} else {
			yield put(azureAdGetLoginUrlFailed(result))
			yield delay(3000) //After 3sec message disappear
			yield put(azureAdGetLoginUrlFailedClear(result))
		}
	} catch (error) {
		yield put(azureAdGetLoginUrlFailed(result))
		yield delay(3000) //After 3sec message disappear
		yield put(azureAdGetLoginUrlFailedClear(result))
	}
}

const azureLoginRequest = async (payload) => {
	return await axios.post(`/auth/authenticate-auth-code?code=${payload.code}`)
}

const logoutUserRequest = async (payload) => {
	return await axios.get(`/auth/logout`)
}

const forgotPassword = async (data) => {
	return await axios
		.post(`/user/notify_reset_password?username=${data}`)
		.then((response) => {
			return response
		})
		.catch((e) => console.log(e))
}

const resetPassword = async (payload) => {
	return await axios
		.post(`/user/reset_password`, payload)
		.then((response) => {
			return response
		})
		.catch((e) => console.log(e))
}

function* azureLoginRequestSaga(action) {
	try {
		const payload = action.payload
		const response = yield call(azureLoginRequest, payload)

		if (response.status === 200 && response.data.success === true) {
			yield put(azureAdLoginRequestSuccess(response?.data)) //update store
			localStorage.setItem("user", JSON.stringify(response?.data))
			const availableProjects = response?.data?.token?.available_projects

			yield put({
				type: LOGIN_SUCCESS,
				payload: response.data,
			})

			yield put(setMultiBaseList(availableProjects))
			yield put(setAIBase(availableProjects[0]))
			localStorage.setItem("selectedProject", JSON.stringify(availableProjects[0]))

			const params = new URL(window.location.href).searchParams
			if (params.get("downloads") === null) {
				yield call(history.push, "/dashboard/")
			} else {
				yield call(history.push, "/downloads?downloads=" + params.get("downloads"))
			}
		} else {
			yield put(azureAdLoginRequestFailed(response))
			yield delay(3000) //After 3sec message disappear
			yield put(azureAdLoginRequestFailedClear(response))
		}
	} catch (error) {
		yield put(azureAdLoginRequestFailed(response))
		yield delay(3000) //After 3sec message disappear
		yield put(azureAdLoginRequestFailedClear(response))
	}
}

function* logoutUserSaga(action) {
	try {
		const payload = action.payload
		const response = yield call(logoutUserRequest, payload)

		if (response?.status === 200 && response?.data?.success === true) {
			yield put(logoutUserActionSuccess(response?.data))
		} else {
			yield put(logoutUserActionFailure(response?.data))
			clearLocalStorage()
			yield put(clearMultibase())
			yield put({
				type: LOGOUT,
				payload: null,
			})
			return
		}
	} catch (error) {
		yield put(logoutUserActionFailure(error))
		if (error?.response?.status === 403) {
			clearLocalStorage()
			yield put(clearMultibase())
			// dispatch(errorUser());
			yield put({
				type: LOGOUT,
				payload: null,
			})
			return
		}
	}
}

function* forgotPasswordSaga(action) {
	try {
		const data = action?.payload
		const result = yield call(forgotPassword, data)
		if (result?.status === 200 && result?.data?.success === true) {
			yield put(forgotPasswordSuccess(data))
			yield put(redirectToHome(true))
		} else {
			yield put(forgotPasswordFailure(result?.data?.message))
			yield put(resetPasswordFailure("Something went wrong. Please contact Anzyz Support."))
			yield put(redirectToHome(true))
		}
	} catch (error) {
		yield put(forgotPasswordFailure("Something went wrong. Please contact Anzyz Support."))
		yield put(redirectToHome(true))
	}
}

function* resetPasswordSaga(action) {
	try {
		const data = action?.payload
		const result = yield call(resetPassword, data)

		if (result && result.status === 200) {
			if (result.data && result.data.success) {
				yield put(resetPasswordSuccess(data))
				yield put(redirectToHome(true))
			} else {
				yield put(resetPasswordFailure("Something went wrong. Please contact Anzyz Support."))
				yield put(redirectToHome(true))
			}
		} else if (result && result.status === 412) {
			yield put(resetPasswordFailure("The reset password link has expired. Please try again."))
			yield put(redirectToHome(true))
		} else {
			// Handle unexpected or undefined result here
			yield put(resetPasswordFailure("The reset password link has expired. Please try again."))
			yield put(redirectToHome(true))
		}
	} catch (error) {
		// Catch any exceptions thrown during the call or in the try block
		console.log("Error in resetPasswordSaga:", error)
		yield put(resetPasswordFailure("Something went wrong. Please contact Anzyz Support."))
		yield put(redirectToHome(true))
	}
}

// Our watcher (saga).  It will watch for many things.
function* loginWatcher() {
	/*
  // Generators halt execution until their next step is ready/occurring
  // So it's not like this loop is firing in the background 1000/sec
  // Instead, it says, "okay, true === true", and hits the first step...
  while (true) {
    //
    // ... and in this first it sees a yield statement with `take` which
    // pauses the loop.  It will sit here and WAIT for this action.
    //
    // yield take(ACTION) just says, when our generator sees the ACTION
    // it will pull from that ACTION's payload that we send up, its
    // email and password.  ONLY when this happens will the loop move
    // forward...
    const { email, password } = yield take(LOGIN_REQUEST)

    // ... and pass the email and password to our loginFlow() function.
    // The fork() method spins up another "process" that will deal with
    // handling the loginFlow's execution in the background!
    // Think, "fork another process".
    //
    // It also passes back to us, a reference to this forked task
    // which is stored in our const task here.  We can use this to manage
    // the task.
    //
    // However, fork() does not block our loop.  It's in the background
    // therefore as soon as our loop executes this it mores forward...
    const task = yield fork(loginFlow, email, password)

    // ... and begins looking for either CLIENT_UNSET or LOGIN_FAILURE!
    // That's right, it gets to here and stops and begins watching
    // for these tasks only.  Why would it watch for login any more?
    // During the life cycle of this generator, the user will login once
    // and all we need to watch for is either logging out, or a login
    // error.  The moment it does grab either of these though it will
    // once again move forward...
    const action = yield take([LOGIN_FAILURE])

    // ... if, for whatever reason, we decide to logout during this
    // cancel the current action.  i.e. the user is being logged
    // in, they get impatient and start hammering the logout button.
    // this would result in the above statement seeing the CLIENT_UNSET
    // action, and down here, knowing that we should cancel the
    // forked `task` that was trying to log them in.  It will do so
    // and move forward...
    if (action.type === LOGOUT) yield cancel(task)

    // ... finally we'll just log them out.  This will unset the client
    // access token ... -> follow this back up to the top of the while loop
    yield call(logoutUser)
  }
  */

	yield takeLatest(LOGIN_REQUEST, loginFlow)
	yield takeLatest(LOGOUT, logoutFlow)

	yield takeLatest(AZUREAD_LOGIN_URL_REQUEST, getAzureAdURLSaga)
	yield takeLatest(AZUREAD_LOGIN_REQUEST, azureLoginRequestSaga)
	yield takeLatest(LOGOUT_USER, logoutUserSaga)
	yield takeLatest(FORGET_PASSWORD, forgotPasswordSaga)
	yield takeLatest(RESET_PASSWORD, resetPasswordSaga)
}

export default loginWatcher
